import { gql } from '@apollo/client';
import type { AppManifest } from '@scio3/shared-types';

/** Apollo query result type for GET_APP_MANIFEST */
export interface AppManifestQueryResult {
  appManifest: AppManifest | null;
}

/** Apollo query variables for GET_APP_MANIFEST */
export interface AppManifestQueryVariables {
  appType: string;
}

/** Fetch manifest for a specific app type (on-demand, not included in ME_QUERY) */
export const GET_APP_MANIFEST = gql`
  query AppManifest($appType: String!) {
    appManifest(appType: $appType)
  }
`;
